import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
// Utilities
import { getEndOfPlace } from 'utilities/Utilities';

import classes from './styles.module.css';

const Prizes:FC = () => {
  const { t } = useTranslation();

  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;
  const prizes:string[] = quiz?.prizes || result?.quizGroup?.prizes || [];
  const spotPrizes = quiz?.spotPrizesEnabled ? quiz?.spotPrizes || [] : [];

  const placeTitles = [t('labels.firstPlace'), t('labels.secondPlace'), t('labels.thirdPlace')];

  const hidePrizes = !prizes.length && !spotPrizes.length;
  if (hidePrizes) return null;
  return (
    <div
      className="relative overflow-hidden rounded-3xl w-full mb-4 p-4 xl:mb-0 shadow-primary-border"
      style={{ 
        backgroundColor: 'rgba(0,0,0,0.6)',
      }}
    >
      <h2
        className={`text-center font-extrabold italic uppercase mb-4 ${classes.prizesTitle}`}
        style={{ color: quiz?.publicLeaderboard.primaryColor }}
      >
        {t('labels.prizes')}
      </h2>
      {prizes.map((prize, index) => {
        const title = index > 2 ? `${index+1}${getEndOfPlace(index+1)} ${t('labels.place')}` : placeTitles[index];
        return (
          <p key={title} className={`text-center uppercase mb-2 last:mb-0 ${classes.prizeItem}`}>{`${title} - ${prize}`}</p>
        )
      })}
      {spotPrizes.map((spotPrize) => {
        return (
          <p key={spotPrize} className={`text-center uppercase mb-2 last:mb-0 ${classes.prizeItem}`}>{`${t('labels.randomPrize')} - ${spotPrize}`}</p>
        )
      })}
    </div>
  )
}

export default Prizes;
